import { UserState } from './slices/user/userSlice';
import { SnackbarState } from './slices/snackbar/snackbarSlice';
import { createBrowserHistory } from 'history';
import { combineReducers, configureStore } from '@reduxjs/toolkit'
import snackbarReducer from './slices/snackbar/snackbarSlice';
import userReducer from './slices/user/userSlice';
import { 
	persistReducer,
	REHYDRATE,
	FLUSH, 
	PAUSE,
	PURGE,
	PERSIST,
	REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

export interface ReduxAction {
	action: string;
	payload: any
}

export interface StateObject {
	user: UserState;
	snackbar: SnackbarState;
}

export const history = createBrowserHistory();

const persistConfig = {
	key: 'root',
	version: 1,
	storage
}

const reducers = combineReducers({
	snackbar: snackbarReducer,
	user: userReducer
});

const persistedReducer = persistReducer(persistConfig, reducers);

export default configureStore({
  reducer: persistedReducer,
	middleware: (getDefaultMiddleware) => getDefaultMiddleware({
		serializableCheck: {
			ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
		}
	})
});
